import { useQuery } from '@tanstack/react-query';

export type UrlsData = {
    signIn: string;
    signUp: string;
};

export const useGetIAMUrls = () => {
    return useQuery({
        queryKey: ['urls'],
        queryFn: async (): Promise<UrlsData> => {
            const response = await fetch(`${process.env.PUBLIC_URL}/urls`);

            const urls = (await response.json()) as UrlsData;

            if (!urls?.signIn || !urls?.signUp) {
                throw Error('invalid iam urls');
            }

            return urls;
        },
    });
};
